import { useCallback } from "react";

export default function useProfileGalleryHook({
  userID,
  totalPG,
  limitPG,
  setState = null,
  setProfileGallery,
  finishGetPhoto,
  isRequestingPG, loadMorePG,
  http
}) {

  const getProfileGallery = useCallback(async () => {
    if (!userID) return;
    if(isRequestingPG || !loadMorePG) return;

    let loadMore = false;

    try {
      const { data = [] } = await http.get("profile/photos", {
        user_profile_id: userID,
        skip: totalPG,
        limit: limitPG,
      });

      loadMore = data.length === limitPG;
      const nextTotal = parseInt(totalPG) + data.length;
      if (setState) {
        setState(prev => ({
          ...prev,
          profile_images: [...prev.profile_images, ...data],
        }));
      }

      setProfileGallery({
        photos: data,
        total: nextTotal,
        loadMore,
      });
    } catch (e) {
      console.error("getProfileGallery", e);
    } finally {
      finishGetPhoto({ loadMore });
    }
  }, [
    http,
    userID,
    totalPG,
    limitPG,
    setState,
    setProfileGallery,
    finishGetPhoto,
    isRequestingPG, loadMorePG
  ]);

  return { getProfileGallery };
}
